import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'initial',
  },
  filtersBar: {
    justifyContent: 'space-between',
    padding: '10px 15px',
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  label: {
    marginRight: 10,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
  },
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  textField: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
  successField: {
    borderColor: theme.custom.accept,
  },
  invalidField: {
    borderColor: theme.custom.warning,
  },
  input: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  warningText: {
    marginBottom: 0,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    color: theme.custom.warning,
  },
  footer: {
    position: 'sticky',
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: 15,
    background: 'rgba(255,255,255,.85)',
  },
  saveBtn: {
    background: theme.custom.accept,
    '&.Mui-disabled': {
      opacity: '.5',
    },
  },
  loader: {
    display: 'block',
  },
  ml15: {
    marginLeft: 15,
  },
}));
